// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import { Modal } from "react-bootstrap";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faFileImage } from "@fortawesome/free-solid-svg-icons";
// import axios from 'axios'
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { RiDeleteBin5Line } from "react-icons/ri";
// import Swal from "sweetalert2";
// import { GrFormView } from "react-icons/gr";
// import { FaEye } from "react-icons/fa";

// function ExamResult() {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const exam = location.state?.exam;
//   const result = location.state?.result;



//   const [showModal, setShowModal] = useState(false);
//   const [modalImg, setModalImg] = useState("");
//   const [showForm, setShowForm] = useState(false);
//   const [results, setResults] = useState(result || []);

//   const [showAnswerModal, setShowAnswerModal] = useState(false);
//   const [selectedAnswers, setSelectedAnswers] = useState(null);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [visibleCount, setVisibleCount] = useState(20);
//   const [loading, setLoading] = useState(false);
//   const [loadingMore, setLoadingMore] = useState(false);


//   const [form, setForm] = useState({
//     id: '',
//     examId: '',
//     student_id: '',
//     correct: '',
//     wrong: '',
//     penalty: '',
//     score: ''
//   });

//   const handleViewAnswers = (row) => {
//     const studentAnswers = JSON.parse(row.answer || "{}");

//     const correctAnswers = {};

//     exam?.questions?.forEach((q) => {
//       correctAnswers[q.question_no] = q.answer;
//     });
//     setSelectedAnswers({ studentAnswers, correctAnswers });
//     setShowAnswerModal(true);
//   };



//   const parsedResult = result.map((student) => ({
//     ...student,
//     answers: JSON.parse(student.answer),
//   }));


//   const getQuestionScore = (studentAnswer, correctAnswer, question) => {
//     if (!studentAnswer || studentAnswer === "") {
//       return -Number(question.penalty || 0); // Not Attempted
//     } else if (studentAnswer === correctAnswer) {
//       return Number(question.correct_marks || 0);
//     } else {
//       return Number(question.wrong_marks || 0);
//     }
//   };



//   const openModal = (img) => {
//     setModalImg(img);
//     setShowModal(true);
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm((prev) => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleEdit = (data) => {

//     setForm({
//       id: data.id,
//       examId: data.exam_id,
//       student_id: data.student_id,
//       correct: data.correct || 0,
//       wrong: data.wrong || 0,
//       penalty: data.penalty || 0,
//       // score: data.score || 0

//       score:
//         exam?.option_count === 4
//           ? calculateTotalMarks(data)
//           : data.score || 0

//     });

//     setShowForm(true);
//   };


//   const handleUpdate = async () => {
//     try {
//       const res = await axios.put(
//         `https://api.scannscore.com/update-exam/${form.id}`,
//         {
//           exam_id: form.examId,
//           student_id: form.student_id,
//           correct: form.correct,
//           wrong: form.wrong,
//           penalty: form.penalty,
//           score: form.score
//         }
//       );

//       if (res.status == 200) {

//         setResults((prev) =>
//           prev.map((item) =>
//             item.id == form.id
//               ? {
//                 ...item,
//                 correct: form.correct,
//                 wrong: form.wrong,
//                 penalty: form.penalty,
//                 score: form.score
//               }
//               : item
//           )
//         );

//         setShowForm(false);
//         toast.success("Exam Updated successfully");
//       }

//     } catch (err) {
//       console.error(err);
//       toast.error("Fail to update exam");
//     }
//   };


//   const handleDelete = async (resultId, omrImg) => {
//     const result = await Swal.fire({
//       title: "Delete Result?",
//       text: "This will permanently delete the result and its data. This action cannot be undone.",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#d33",
//       cancelButtonColor: "#6c757d",
//       confirmButtonText: "Yes, delete it",
//       cancelButtonText: "Cancel",
//     });

//     if (result.isConfirmed) {
//       try {
//         await axios.delete(`https://api.scannscore.com/delete-result/${resultId}/${omrImg}`);

//         Swal.fire({
//           icon: "success",
//           title: "Deleted!",
//           text: "The exam has been successfully deleted.",
//           timer: 1500,
//           showConfirmButton: false,
//         });

//         navigate(-1);

//       } catch (error) {
//         // console.log(error)
//         Swal.fire({
//           icon: "error",
//           title: "Error",
//           text: "Failed to delete the exam. Please try again.",
//         });
//       }
//     }
//   };



//   const exportToExcel = () => {
//     if (!result || result.length === 0) return;

//     const data = result.map((r) => {
//       const answers = JSON.parse(r.answer || "{}");


//       // const attempted = Object.values(answers).filter(
//       //   (a) => a !== "" && a !== null
//       // ).length;

//      const totalQuestions = exam?.questions?.length || 0;

//                   const unattempted = exam?.questions?.filter((q) => {
                    
//                     const answers = JSON.parse(r.answer || "{}");

//                     const ans = String(answers[String(q.question_no)] ?? "")
//                       .trim();

//                     return ans === "-";
//                   }).length;
// // const attempted = r.correct + r.wrong;
// // const unattempted = totalQuestions - attempted;

//                   const attempted = totalQuestions - unattempted;



//       return {
//         "Exam Title": exam?.exam_title,
//         "Student Name": r.student_name,
//         "Enrollment No": r.student_roll_no,
//         "Total Questions": exam?.total_questions,
//         // "Total Marks": r.score,
//         "Total Marks": calculateTotalMarks(r),
//         "Attempted Questions": attempted,
//         "OMR Image": `https://api.scannscore.com/uploads/${r.omr_img}`,
//       };
//     });

//     const worksheet = XLSX.utils.json_to_sheet(data);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Results");

//     const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
//     const fileData = new Blob([excelBuffer], { type: "application/octet-stream" });
//     saveAs(fileData, "ExamResults.xlsx");
//   };



//   const filteredData = React.useMemo(() => {
//     if (!results) return [];

//     return results.filter((itm) =>
//       Object.values(itm).some((val) =>
//         String(val).toLowerCase().includes(searchTerm.toLowerCase())
//       )
//     );
//   }, [results, searchTerm]);

 


//   useEffect(() => {
//     setLoading(true);

//     const timer = setTimeout(() => {
//       setLoading(false);
//     }, 300); // small delay for smooth UI

//     return () => clearTimeout(timer);
//   }, [searchTerm, result]);





// const calculateTotalMarks = (row) => {
//   const answers = JSON.parse(row.answer || "{}");

//   let total = 0;

//   const penalty = Number(exam?.penalty ?? 0);

//   exam?.questions?.forEach((q) => {
//     const qNo = String(q.question_no);

//     const correctAns = String(q.answer || "")
//       .trim()
//       .toUpperCase();

//     const studentAnswer = String(answers[qNo] ?? "")
//       .trim()
//       .toUpperCase();

//     // Get marks for THIS question
//     const correctMarks = Number(
//       q?.correct_marks ?? exam?.correct_marks ?? 0
//     );

//     const wrongMarks = Number(
//       q?.wrong_marks ?? exam?.wrong_marks ?? 0
//     );


//     if (exam?.option_count === 4 && studentAnswer === "E") {
//       return;
//     }


//     if (studentAnswer === "" || studentAnswer === "-") {
//       total -= penalty;
//       return;
//     }


//     if (studentAnswer === correctAns) {
//       total += correctMarks;
//       return;
//     }

//     total -= wrongMarks;
//   });

//   return total;
// };

//   return (
//     <div className="container-fluid p-3" style={{ minHeight: "100vh" }}>
//       <div className="d-flex justify-content-between align-items-center mb-4">
//         <h2>Exam Result</h2>
//         <div>
//           <button className="btn btn-success me-2" onClick={exportToExcel}>
//             Download Excel
//           </button>
//           <button className="btn btn-secondary" onClick={() => navigate(-1)}>
//             Back
//           </button>
//         </div>
//       </div>

//       <div className="col-12 col-md-4 mb-3">
//         <input
//           type="text"
//           className="form-control border-info "
//           placeholder="Search by name,roll no..."
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//         />
//       </div>



//       {showForm && (


//         <div className='card p-3 mb-3' >
//           <form onSubmit={(e) => e.preventDefault()} >

//             <h5 className="mt-1 fs-4 text-center fw-semibold text-primary">Edit Exam </h5>

//             <hr />

//             <div className='row g-3'>

//               <div className="col-md-4">
//                 <label htmlFor="title" className="form-label fw-medium">Correct Answer </label>
//                 <input type="number" className="form-control" name="correct" placeholder="Enter here..." value={form.correct} required onChange={handleChange} />
//               </div>

//               <div className="col-md-4">
//                 <label htmlFor="title" className="form-label fw-medium">Wrong Answer </label>
//                 <input type="number" className="form-control" name="wrong" placeholder="Enter here..." value={form.wrong} required onChange={handleChange} />
//               </div>

//               <div className="col-md-4">
//                 <label htmlFor='name' className="form-label fw-medium" >Unattempted Ques</label>
//                 <input type="number" className="form-control" name="penalty" placeholder="Enter here..." value={form.penalty} required onChange={handleChange} />
//               </div>

//               <div className="col-md-4">
//                 <label htmlFor='middle' className="form-label fw-medium" >Score</label>
//                 <input type="number" className="form-control" name="score" placeholder="Enter here..."
//                   value={form.score}

//                   onChange={handleChange}
//                 />
//               </div>

//               <div className='gap-2 d-flex justify-content-center mt-4'>

//                 {/* <button className='btn btn-success' onClick={ () => handleUpdate()} >Save</button> */}
//                 <button type="button" className='btn btn-success' onClick={handleUpdate}>
//                   Save
//                 </button>
//                 <button type='button' className='btn btn-danger w-10 ms-2' onClick={() => {
//                   setShowForm(false);
//                   setForm({
//                     correct: '',
//                     wrong: '',
//                     penalty: '',
//                     score: ''
//                   });

//                 }}>
//                   Cancel
//                 </button>
//               </div>

//             </div>
//           </form>
//         </div>
//       )}


//       <div className="table-responsive">
//         <table className="table table-bordered table-striped table-hover text-center align-middle">
//           <thead className="table-light">
//             <tr>
//               <th>Sr No.</th>
//               <th>Exam Title</th>
//               <th>Student Name</th>
//               <th>Enroll No</th>
//               <th>Total Ques</th>
//               <th>Total Marks</th>
//               <th>Attempted</th>
//               <th>View </th>
//               <th>Documents</th>
//               <th>Action </th>
//             </tr>
//           </thead>
//           <tbody>
//             {loading ? (
//               <tr>
//                 <td colSpan="10" className="text-center py-4">
//                   Loading results...
//                 </td>
//               </tr>
//             ) :
//               filteredData?.length > 0 ? (
//                 filteredData.map((r, index) => {
//                   const answers = JSON.parse(r.answer || "{}");

//                   const totalQuestions = exam?.questions?.length || 0;

                 

//                   const attempted = r.correct + r.wrong;
// const unattempted = totalQuestions - attempted;

//                   return (
//                     <tr key={index}>
//                       <td>{index + 1}</td>
//                       <td>{exam?.exam_title}</td>
//                       <td>{r.student_name}</td>
//                       <td>{r.student_roll_no}</td>
//                       <td>{exam?.total_questions}</td>
                    

//                       <td>
//   {exam?.option_count === 4
//     ? Number(calculateTotalMarks(r)).toFixed(2)
//     : Number(r.score).toFixed(2)}
// </td>
//                       <td>{attempted}</td>
//                       <td>
//                         <FaEye
//                           className="text-info"
//                           size={28}
//                           style={{ cursor: "pointer" }}
//                           title="View"
//                           onClick={() => handleViewAnswers(r)}
//                         />
//                       </td>
//                       <td>
//                         {r.omr_img ? (
//                           <FontAwesomeIcon
//                             icon={faFileImage}
//                             style={{ cursor: "pointer", fontSize: '1.4em' }}
//                             onClick={() =>
//                               openModal(`https://api.scannscore.com/uploads/${r.omr_img}`)
//                             }
//                           />



//                         ) : (
//                           "No Image"
//                         )}
//                       </td>
//                       <td >
//                         {/* <button className="btn btn-primary" onClick={() => handleEdit(r)}> Edit</button> */}
//                         <button className="btn btn-danger mx-2" onClick={() => handleDelete(r.id, r.omr_img)} >Delete </button>
//                       </td>

//                     </tr>
//                   );
//                 })
//               ) : (
//                 <tr>
//                   <td colSpan="7">No result found</td>
//                 </tr>
//               )}
//           </tbody>
//         </table>
//       </div>


//       <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
//         <Modal.Body>
//           <img src={modalImg} alt="OMR" style={{ width: "100%" }} />
//         </Modal.Body>
//       </Modal>


//       <Modal
//         show={showAnswerModal}
//         onHide={() => setShowAnswerModal(false)}
//         size="lg"
//         centered
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Answer Sheet</Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           {!selectedAnswers && <p>No data available</p>}

//           {selectedAnswers && (


//             <div className="table-responsive">
//               <table className="table table-bordered text-center">
//                 <thead>
//                   <tr>
//                     <th>Q No</th>
//                     <th>Correct Answer</th>
//                     <th>Student Answer</th>
//                     <th>Status</th>
//                     <th>Marks</th>
//                   </tr>
//                 </thead>
         

//                 <tbody>
//                   {Object.keys(selectedAnswers.correctAnswers || {}).map((qNo) => {
//                     const correct = selectedAnswers.correctAnswers[qNo];
//                     const studentAnswer = selectedAnswers.studentAnswers[qNo];

//                     let status = "Not Attempted";
//                     let color = "gray";
//                     let marks = 0;

//                     if (!studentAnswer || studentAnswer === "" || studentAnswer == '-') {
//                       status = "Not Attempted";
//                       color = "gray";
//                       marks = -Number(exam?.penalty ?? 0);
//                     }

//                     // Skip E option for 4-option exams
//                     else if (
//                       exam?.option_count === 4 &&
//                       studentAnswer === "E"
//                     ) {
//                       status = "Skipped";
//                       color = "orange";
//                       marks = 0;
//                     }

//                     else if (studentAnswer === correct) {
//                       status = "Correct";
//                       color = "green";
//                       marks = Number(exam?.correct_marks ?? 0);
//                     }

//                     else {
//                       status = "Wrong";
//                       color = "red";
//                       marks = -Number(exam?.wrong_marks ?? 0);
//                     }

//                     return (
//                       <tr key={qNo}>
//                         <td>{qNo}</td>
//                         <td>{correct}</td>
//                         <td>{studentAnswer || "-"}</td>
//                         <td style={{ color }}>{status}</td>
//                         <td>{marks}</td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </Modal.Body>
//       </Modal>
//     </div>
//   );
// }

// export default ExamResult;



import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileImage } from "@fortawesome/free-solid-svg-icons";
import axios from 'axios'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RiDeleteBin5Line } from "react-icons/ri";
import Swal from "sweetalert2";
import { GrFormView } from "react-icons/gr";
import { FaEye } from "react-icons/fa";

function ExamResult() {
  const navigate = useNavigate();
  const location = useLocation();

  const exam = location.state?.exam;
  const result = location.state?.result;



  const [showModal, setShowModal] = useState(false);
  const [modalImg, setModalImg] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [results, setResults] = useState(result || []);

  const [showAnswerModal, setShowAnswerModal] = useState(false);
  const [selectedAnswers, setSelectedAnswers] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [visibleCount, setVisibleCount] = useState(20);
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);




  const [form, setForm] = useState({
    id: '',
    examId: '',
    student_id: '',
    correct: '',
    wrong: '',
    penalty: '',
    score: ''
  });

  const handleViewAnswers = (row) => {
    const studentAnswers = JSON.parse(row.answer || "{}");

    const correctAnswers = {};

    exam?.questions?.forEach((q) => {
      correctAnswers[q.question_no] = q.answer;
    });
    setSelectedAnswers({ studentAnswers, correctAnswers });
    setShowAnswerModal(true);
  };



  const parsedResult = result.map((student) => ({
    ...student,
    answers: JSON.parse(student.answer),
  }));


  const getQuestionScore = (studentAnswer, correctAnswer, question) => {
    if (!studentAnswer || studentAnswer === "") {
      return -Number(question.penalty || 0); // Not Attempted
    } else if (studentAnswer === correctAnswer) {
      return Number(question.correct_marks || 0);
    } else {
      return Number(question.wrong_marks || 0);
    }
  };



  const openModal = (img) => {
    setModalImg(img);
    setShowModal(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleEdit = (data) => {

    setForm({
      id: data.id,
      examId: data.exam_id,
      student_id: data.student_id,
      correct: data.correct || 0,
      wrong: data.wrong || 0,
      penalty: data.penalty || 0,
      // score: data.score || 0

      score:
        exam?.option_count === 4
          ? calculateTotalMarks(data)
          : data.score || 0

    });

    setShowForm(true);
  };


  const handleUpdate = async () => {
    try {
      const res = await axios.put(
        `https://api.scannscore.com/update-exam/${form.id}`,
        {
          exam_id: form.examId,
          student_id: form.student_id,
          correct: form.correct,
          wrong: form.wrong,
          penalty: form.penalty,
          score: form.score
        }
      );

      if (res.status == 200) {

        setResults((prev) =>
          prev.map((item) =>
            item.id == form.id
              ? {
                ...item,
                correct: form.correct,
                wrong: form.wrong,
                penalty: form.penalty,
                score: form.score
              }
              : item
          )
        );

        setShowForm(false);
        toast.success("Exam Updated successfully");
      }

    } catch (err) {
      console.error(err);
      toast.error("Fail to update exam");
    }
  };


  const handleDelete = async (resultId, omrImg) => {
    const result = await Swal.fire({
      title: "Delete Result?",
      text: "This will permanently delete the result and its data. This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, delete it",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(`https://api.scannscore.com/delete-result/${resultId}/${omrImg}`);

        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "The exam has been successfully deleted.",
          timer: 1500,
          showConfirmButton: false,
        });

        navigate(-1);

      } catch (error) {
        // console.log(error)
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to delete the exam. Please try again.",
        });
      }
    }
  };



  const exportToExcel = () => {
    if (!result || result.length === 0) return;

    const data = result.map((r) => {
      const answers = JSON.parse(r.answer || "{}");



     const totalQuestions = exam?.questions?.length || 0;

  

                  const unattempted = exam?.questions?.filter((q) => {
                    
                    const answers = JSON.parse(r.answer || "{}");

                    const ans = String(answers[String(q.question_no)] ?? "")
                      .trim();

                    return ans === "-";
                  }).length;
// const attempted = r.correct + r.wrong;
// const unattempted = totalQuestions - attempted;

                  const attempted = totalQuestions - unattempted;



      return {
        "Exam Title": exam?.exam_title,
        "Student Name": r.student_name,
        "Enrollment No": r.student_roll_no,
        "Total Questions": exam?.total_questions,
        // "Total Marks": r.score,
        "Total Marks": calculateTotalMarks(r),
        "Attempted Questions": attempted,
        "OMR Image": `https://api.scannscore.com/uploads/${r.omr_img}`,
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Results");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const fileData = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(fileData, "ExamResults.xlsx");
  };



  const filteredData = React.useMemo(() => {
    if (!results) return [];

    return results.filter((itm) =>
      Object.values(itm).some((val) =>
        String(val).toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [results, searchTerm]);

 


  useEffect(() => {
    setLoading(true);

    const timer = setTimeout(() => {
      setLoading(false);
    }, 300); // small delay for smooth UI

    return () => clearTimeout(timer);
  }, [searchTerm, result]);





const calculateTotalMarks = (row) => {
  const answers = JSON.parse(row.answer || "{}");

  let total = 0;

  const penalty = Number(exam?.penalty ?? 0);

  exam?.questions?.forEach((q) => {
    const qNo = String(q.question_no);

    const correctAns = String(q.answer || "")
      .trim()
      .toUpperCase();

    const studentAnswer = String(answers[qNo] ?? "")
      .trim()
      .toUpperCase();

    // Get marks for THIS question
    const correctMarks = Number(
      q?.correct_marks ?? exam?.correct_marks ?? 0
    );

    const wrongMarks = Number(
      q?.wrong_marks ?? exam?.wrong_marks ?? 0
    );


    if (exam?.option_count === 4 && studentAnswer === "E") {
      return;
    }


    if (studentAnswer === "" || studentAnswer === "-") {
      total -= penalty;
      return;
    }


    if (studentAnswer === correctAns) {
      total += correctMarks;
      return;
    }

    total -= wrongMarks;
  });

  return total;
};

  return (
    <div className="container-fluid p-3" style={{ minHeight: "100vh" }}>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Exam Result</h2>
        <div>
          <button className="btn btn-success me-2" onClick={exportToExcel}>
            Download Excel
          </button>
          <button className="btn btn-secondary" onClick={() => navigate(-1)}>
            Back
          </button>
        </div>
      </div>

      <div className="col-12 col-md-4 mb-3">
        <input
          type="text"
          className="form-control border-info "
          placeholder="Search by name,roll no..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>



      {showForm && (


        <div className='card p-3 mb-3' >
          <form onSubmit={(e) => e.preventDefault()} >

            <h5 className="mt-1 fs-4 text-center fw-semibold text-primary">Edit Exam </h5>

            <hr />

            <div className='row g-3'>

              <div className="col-md-4">
                <label htmlFor="title" className="form-label fw-medium">Correct Answer </label>
                <input type="number" className="form-control" name="correct" placeholder="Enter here..." value={form.correct} required onChange={handleChange} />
              </div>

              <div className="col-md-4">
                <label htmlFor="title" className="form-label fw-medium">Wrong Answer </label>
                <input type="number" className="form-control" name="wrong" placeholder="Enter here..." value={form.wrong} required onChange={handleChange} />
              </div>

              <div className="col-md-4">
                <label htmlFor='name' className="form-label fw-medium" >Unattempted Ques</label>
                <input type="number" className="form-control" name="penalty" placeholder="Enter here..." value={form.penalty} required onChange={handleChange} />
              </div>

              <div className="col-md-4">
                <label htmlFor='middle' className="form-label fw-medium" >Score</label>
                <input type="number" className="form-control" name="score" placeholder="Enter here..."
                  value={form.score}

                  onChange={handleChange}
                />
              </div>

              <div className='gap-2 d-flex justify-content-center mt-4'>

                {/* <button className='btn btn-success' onClick={ () => handleUpdate()} >Save</button> */}
                <button type="button" className='btn btn-success' onClick={handleUpdate}>
                  Save
                </button>
                <button type='button' className='btn btn-danger w-10 ms-2' onClick={() => {
                  setShowForm(false);
                  setForm({
                    correct: '',
                    wrong: '',
                    penalty: '',
                    score: ''
                  });

                }}>
                  Cancel
                </button>
              </div>

            </div>
          </form>
        </div>
      )}


      <div className="table-responsive">
        <table className="table table-bordered table-striped table-hover text-center align-middle">
          <thead className="table-light">
            <tr>
              <th>Sr No.</th>
              <th>Exam Title</th>
              <th>Student Name</th>
              <th>Enroll No</th>
              <th>Total Ques</th>
              <th>Total Marks</th>
              <th>Attempted</th>
              <th>View </th>
              <th>Documents</th>
              <th>Action </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="10" className="text-center py-4">
                  Loading results...
                </td>
              </tr>
            ) :
              filteredData?.length > 0 ? (
                filteredData.map((r, index) => {
                  const answers = JSON.parse(r.answer || "{}");

                  let attempted = 0;

Object.values(answers).forEach((ans) => {
  if (ans !== "" && ans !== null && ans !== "-") {
    attempted++;
  }
});

const totalQuestions = Object.keys(answers).length;
const unattempted = totalQuestions - attempted;


                  // const totalQuestions = exam?.questions?.length || 0;
              //     const attempted = r.correct + r.wrong;
              // const unattempted = totalQuestions - attempted;

                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{exam?.exam_title}</td>
                      <td>{r.student_name}</td>
                      <td>{r.student_roll_no}</td>
                      <td>{exam?.total_questions}</td>
                    

                      <td>
  {exam?.option_count === 4
    ? Number(calculateTotalMarks(r)).toFixed(2)
    : Number(r.score).toFixed(2)}
</td>
                  <td>{attempted}</td>
                      <td>
                        <FaEye
                          className="text-info"
                          size={28}
                          style={{ cursor: "pointer" }}
                          title="View"
                          onClick={() => handleViewAnswers(r)}
                        />
                      </td>
                      <td>
                        {r.omr_img ? (
                          <FontAwesomeIcon
                            icon={faFileImage}
                            style={{ cursor: "pointer", fontSize: '1.4em' }}
                            onClick={() =>
                              openModal(`https://api.scannscore.com/uploads/${r.omr_img}`)
                            }
                          />



                        ) : (
                          "No Image"
                        )}
                      </td>
                      <td >
                        {/* <button className="btn btn-primary" onClick={() => handleEdit(r)}> Edit</button> */}
                        <button className="btn btn-danger mx-2" onClick={() => handleDelete(r.id, r.omr_img)} >Delete </button>
                      </td>

                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="7">No result found</td>
                </tr>
              )}
          </tbody>
        </table>
      </div>


      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
        <Modal.Body>
          <img src={modalImg} alt="OMR" style={{ width: "100%" }} />
        </Modal.Body>
      </Modal>


      <Modal
        show={showAnswerModal}
        onHide={() => setShowAnswerModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Answer Sheet</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {!selectedAnswers && <p>No data available</p>}

          {selectedAnswers && (


            <div className="table-responsive">
              <table className="table table-bordered text-center">
                <thead>
                  <tr>
                    <th>Q No</th>
                    <th>Correct Answer</th>
                    <th>Student Answer</th>
                    <th>Status</th>
                    <th>Marks</th>
                  </tr>
                </thead>
         

                <tbody>
                  {Object.keys(selectedAnswers.correctAnswers || {}).map((qNo) => {
                    const correct = selectedAnswers.correctAnswers[qNo];
                    const studentAnswer = selectedAnswers.studentAnswers[qNo];

                    let status = "Not Attempted";
                    let color = "gray";
                    let marks = 0;

                    if (!studentAnswer || studentAnswer === "") {
                      status = "Not Attempted";
                      color = "gray";
                      marks = -Number(exam?.penalty ?? 0);
                    }

                    // Skip E option for 4-option exams
                    else if (
                      exam?.option_count === 4 &&
                      studentAnswer === "E"
                    ) {
                      status = "Skipped";
                      color = "orange";
                      marks = 0;
                    }

                    else if (studentAnswer === correct) {
                      status = "Correct";
                      color = "green";
                      marks = Number(exam?.correct_marks ?? 0);
                    }

                    else {
                      status = "Wrong";
                      color = "red";
                      marks = -Number(exam?.wrong_marks ?? 0);
                    }

                    return (
                      <tr key={qNo}>
                        <td>{qNo}</td>
                        <td>{correct}</td>
                        <td>{studentAnswer || "-"}</td>
                        <td style={{ color }}>{status}</td>
                        <td>{marks}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default ExamResult;
